import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-divider',
  templateUrl: './divider.component.html',
  styleUrls: ['./divider.component.css']
})
export class DividerComponent{
  

  @Input() titleDivider: string;

  @Input() white = false;
  constructor() { }

  ngOnInit() { }
}
